export const CheckoutPage = r => require.ensure([], () => r(require('../components/CheckoutPage')), 'Checkout-bundle')

const children = [
  {
    name: 'checkout.index',
    path: ':checkoutId',
    component: CheckoutPage,
    meta: {
      requiresAuth: false,
      title: 'Checkout',
      permission: 'public',
      breadcrumbs: [
        {
          name: 'Checkout',
          pathName: 'checkout.index'
        },
      ]
    }
  }
]

export default [{
  name: 'checkout',
  children,
  path: '/checkout',
  component: CheckoutPage,
  redirect: { name: 'checkout.index', params: { checkoutId: '' } },
  meta: {
    requiresAuth: false,
  }
}]
